import "@/components/skeleton/dashboard-skeleton.css";

/** A single shimmer bar (mirrors the shared skeleton primitive). */
function Bar({ w, h = 12, r = 6, style }: { w: number | string; h?: number; r?: number; style?: React.CSSProperties }) {
  return <span className="sk" style={{ width: w, height: h, borderRadius: r, ...style }} />;
}

/**
 * Dedicated loader for the By-Branch table — separate from the global
 * `DashboardMetricsSkeleton` so this lazy section shimmers on its own. Mirrors
 * the table's toolbar + `clintbl` header/rows so the real table drops in without
 * a layout shift. Doubles as the Suspense fallback while the chunk downloads.
 */
export default function BranchTablePanelSkeleton({ cols = 6, rows = 8 }: { cols?: number; rows?: number }) {
  const colArr = Array.from({ length: cols });
  const rowArr = Array.from({ length: rows });
  return (
    <div className="pp-card" style={{ padding: 0, overflow: "visible" }} aria-hidden="true">
      <div className="tbl-toolbar">
        <Bar w={150} h={13} />
        <Bar w={150} h={30} r={8} style={{ marginLeft: 10 }} />
        <div style={{ flex: 1 }} />
        <Bar w={92} h={30} r={8} />
      </div>
      <div style={{ overflowX: "auto" }}>
        <table className="clintbl">
          <thead>
            <tr>
              <th><Bar w={90} h={11} /></th>
              {colArr.map((_, i) => (
                <th key={i}><Bar w={64} h={11} /></th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rowArr.map((_, r) => (
              <tr key={r}>
                <td><Bar w={140} h={11} /></td>
                {colArr.map((_, c) => (
                  <td key={c}><Bar w={48} h={11} /></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
